import script from "./TravelForBeginners.vue?vue&type=script&lang=ts&setup=true"
export * from "./TravelForBeginners.vue?vue&type=script&lang=ts&setup=true"

import "./TravelForBeginners.vue?vue&type=style&index=0&id=3ee1e31c&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ee1e31c"]])

export default __exports__